import { ToLogin } from "./ToLogin";
import { FC } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { StateType } from "../backend/store";
import { isAdminOrSuperAdmin, getDefaultLandingPage } from "../utils/permissions";

type Props = {
  children: any;
};

/**
 * Fix round 1. Restricts a route to `isAdminOrSuperAdmin` — the account's
 * MAIN-workspace role (`user.role`, `User::role()` on the backend), NOT the
 * currently-selected workspace's role `RoleRoute` checks. A separate,
 * dedicated guard rather than widening `RoleRoute` itself: `RoleRoute` is
 * used by several other routes (`/admin/dashboard`,
 * `/admin/geocoding-shadow`) for the genuinely different "role in THIS
 * workspace" question, and re-pointing it here would be a much wider,
 * unreviewed change. `/chabad-house/add` needs the MAIN-workspace answer
 * specifically because that's what `ChabadCenterPolicy::connect` (the
 * backend gate on `POST /api/centers/connect`, the endpoint this whole
 * screen exists to call) actually checks — see `isAdminOrSuperAdmin`'s own
 * doc comment in `utils/permissions.ts` for the two-way mismatch this fixes.
 */
export const AdminOrSuperAdminRoute: FC<Props> = ({ children }) => {
  const isUser = localStorage.getItem("user");
  const currentUser = useSelector((state: StateType) => state.authStore.currentUser);

  if (!isUser) {
    return <ToLogin />
  }

  if (currentUser && !isAdminOrSuperAdmin(currentUser)) {
    return <Navigate to={getDefaultLandingPage(currentUser)} />;
  }

  return children;
};
